var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M9.19 16.19l-3.5-3.5a.99.99 0 10-1.4 1.4l4.193 4.193a1 1 0 001.414 0L20.49 7.69a.99.99 0 10-1.4-1.4l-9.9 9.9z', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function okayMultiselect(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};